import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CourseItem from "../card/CourseItem";
import { useDispatch, useSelector } from "react-redux";
import { getPrograms } from "../../../../api/afterLogin/program";
import NoItemsInfo from "../NoItemsInfo";
import { setConfigData } from "../../../../reducers/configSlice";
import { getSPAuthTokens } from "../../../../helpers/spauth_token_helper";

const ApprenticeshipCarousel = ({ setHasError }) => {
  const configData = useSelector((state) => state.config);
  const adminData = useSelector((state) => state.admin);
  const [apprenticeshipData, setApprenticeshipData] = useState([]);
  const dispatch = useDispatch();

  const fetchApprenticeship = async (eportfolioToken) => {
    try{
    const products = adminData.products ?? [];
    if (products.length > 0) {
      const programs = await getPrograms(configData.user_uuid, products, eportfolioToken);
      if(programs != false) {
        setApprenticeshipData(programs);
      } else {
        setApprenticeshipData([]);
      }
    }
    } catch (error){
      setHasError(true);
      console.error(error);
    } 
  };

  useEffect(() => {
    if (configData.access_token) {
      const fetchTokenData = async () => {
        const tokenData = await getSPAuthTokens('eportfolio', configData.access_token);
        if (tokenData !== '') {
          fetchApprenticeship(tokenData);
        } else {
          fetchApprenticeship('');
        }
      };
      fetchTokenData();
    }
  }, [adminData]);

  const courseData = apprenticeshipData.map((value) => {
          return {
            className: "",
            courseImage: value.member_program.program_image_url,
            courseType: "Course",
            courseTitle: value.member_program.program_name,
            courseLectureCount: value.member_sections.length + " Sections",
            courseTypeLearning: "Apprenticeship",
          }
    });

  const ref = useRef(null);
  const programCount = apprenticeshipData?.filter(item => item.member_program).length ?? false;
if (programCount) {
  dispatch(setConfigData({programcount: programCount }));
}
  const settings = {
    margin: "10",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          rows: 1,
          variableWidth: false,
        },
      },
      {
        breakpoint: 1368,
        settings: {
          slidesToShow: 2,
          rows: 2,
          variableWidth: false,
        },
      },
    ],
  };

  return (
    <>
    {courseData.length === 0 ? (
      <NoItemsInfo 
        className="myk__stu-empty-com_courseapprent" 
        title="No Completed Apprenticeships Yet!"
        description="Once you complete your apprenticeships, it will appear here." 
      />
    ) : (
      <Slider {...settings} ref={ref}>
        {courseData.map((course, index) => (
          <CourseItem key={index} {...course} />
        ))}
      </Slider>
    )}
    </>
  );
};

export default ApprenticeshipCarousel;
